import { Record } from "../fable_modules/fable-library.4.5.0/Types.js";
import { array_type, uint8_type, class_type, bool_type, option_type, int32_type, record_type, string_type } from "../fable_modules/fable-library.4.5.0/Reflection.js";

export class GenericResponse extends Record {
    constructor(Result, Message) {
        super();
        this.Result = Result;
        this.Message = Message;
    }
}

export function GenericResponse_$reflection() {
    return record_type("Shared.GenericResponse", [], GenericResponse, () => [["Result", string_type], ["Message", string_type]]);
}

export function GenericResponse_Success_Z721C83C5(msg) {
    return new GenericResponse("success", msg);
}

export function GenericResponse_Failure_Z721C83C5(msg) {
    return new GenericResponse("failure", msg);
}

export class Document$ extends Record {
    constructor(Guid, Number$, CustomerId, Title, CategoryTreeId, TypeId, SourceId, Date$, IsHidden, IsDeleted, Version, Uploaded, ContentId, Filename, ContentSizeBytes) {
        super();
        this.Guid = Guid;
        this.Number = Number$;
        this.CustomerId = (CustomerId | 0);
        this.Title = Title;
        this.CategoryTreeId = CategoryTreeId;
        this.TypeId = TypeId;
        this.SourceId = (SourceId | 0);
        this.Date = Date$;
        this.IsHidden = IsHidden;
        this.IsDeleted = IsDeleted;
        this.Version = (Version | 0);
        this.Uploaded = Uploaded;
        this.ContentId = ContentId;
        this.Filename = Filename;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
    }
}

export function Document$_$reflection() {
    return record_type("Shared.Document", [], Document$, () => [["Guid", string_type], ["Number", option_type(int32_type)], ["CustomerId", int32_type], ["Title", string_type], ["CategoryTreeId", option_type(int32_type)], ["TypeId", option_type(int32_type)], ["SourceId", int32_type], ["Date", option_type(string_type)], ["IsHidden", bool_type], ["IsDeleted", bool_type], ["Version", int32_type], ["Uploaded", class_type("System.DateTime")], ["ContentId", option_type(int32_type)], ["Filename", string_type], ["ContentSizeBytes", int32_type]]);
}

export class DocumentForm extends Record {
    constructor(Title, Filename, Content, CategoryTreeId, TypeId, Number$, Version, IsHidden, ContentSizeBytes, Date$) {
        super();
        this.Title = Title;
        this.Filename = Filename;
        this.Content = Content;
        this.CategoryTreeId = CategoryTreeId;
        this.TypeId = TypeId;
        this.Number = Number$;
        this.Version = Version;
        this.IsHidden = IsHidden;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
        this.Date = Date$;
    }
}

export function DocumentForm_$reflection() {
    return record_type("Shared.DocumentForm", [], DocumentForm, () => [["Title", string_type], ["Filename", string_type], ["Content", string_type], ["CategoryTreeId", option_type(int32_type)], ["TypeId", option_type(int32_type)], ["Number", option_type(int32_type)], ["Version", option_type(int32_type)], ["IsHidden", bool_type], ["ContentSizeBytes", int32_type], ["Date", option_type(string_type)]]);
}

export class DocumentContent extends Record {
    constructor(Name, Content) {
        super();
        this.Name = Name;
        this.Content = Content;
    }
}

export function DocumentContent_$reflection() {
    return record_type("Shared.DocumentContent", [], DocumentContent, () => [["Name", string_type], ["Content", array_type(uint8_type)]]);
}

export class ScanResult extends Record {
    constructor(VirusFound, Message, Filename) {
        super();
        this.VirusFound = VirusFound;
        this.Message = Message;
        this.Filename = Filename;
    }
}

export function ScanResult_$reflection() {
    return record_type("Shared.ScanResult", [], ScanResult, () => [["VirusFound", bool_type], ["Message", string_type], ["Filename", string_type]]);
}

export function ScanResult_get_empty() {
    return new ScanResult(false, "", "");
}

export class ScanError extends Record {
    constructor(FileName, Message) {
        super();
        this.FileName = FileName;
        this.Message = Message;
    }
}

export function ScanError_$reflection() {
    return record_type("Shared.ScanError", [], ScanError, () => [["FileName", string_type], ["Message", string_type]]);
}

export class ScanResults extends Record {
    constructor(Results, Errors) {
        super();
        this.Results = Results;
        this.Errors = Errors;
    }
}

export function ScanResults_$reflection() {
    return record_type("Shared.ScanResults", [], ScanResults, () => [["Results", array_type(ScanResult_$reflection())], ["Errors", array_type(ScanError_$reflection())]]);
}

export class UploadResult extends Record {
    constructor(ScanResult, Document$) {
        super();
        this.ScanResult = ScanResult;
        this.Document = Document$;
    }
}

export function UploadResult_$reflection() {
    return record_type("Shared.UploadResult", [], UploadResult, () => [["ScanResult", ScanResult_$reflection()], ["Document", Document$_$reflection()]]);
}

